import { render, staticRenderFns } from "./LostInventories.vue?vue&type=template&id=0c59bbae"
import script from "./LostInventories.vue?vue&type=script&lang=js"
export * from "./LostInventories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports